import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;
const TOKEN_KEY = "era_motor_token";

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      clearToken();
      if (window.location.pathname !== "/login") {
        // Tur 2.5C: kullanıcının geldiği yolu ?next= ile koru
        const next = encodeURIComponent(window.location.pathname + window.location.search);
        window.location.href = `/login?next=${next}`;
      }
    }
    return Promise.reject(err);
  },
);

export function saveToken(t) { localStorage.setItem(TOKEN_KEY, t); }
export function clearToken() { localStorage.removeItem(TOKEN_KEY); }
export function getToken() { return localStorage.getItem(TOKEN_KEY); }

export function formatTRY(v) {
  const n = Number(v || 0);
  return new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY", minimumFractionDigits: 2 }).format(n);
}

export function formatDateTR(iso) {
  if (!iso) return "-";
  try {
    const d = typeof iso === "string" && iso.length === 10 ? new Date(iso + "T00:00:00") : new Date(iso);
    if (isNaN(d)) return iso;
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${dd}.${mm}.${yyyy}`;
  } catch { return iso; }
}

export function todayISO() {
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}

/** Convert Turkish phone number to international WhatsApp-compatible digits.
 * Examples:
 *   "0532 111 22 33" -> "905321112233"
 *   "532 111 22 33"  -> "905321112233"
 *   "+90 532 ..."    -> "905321112233"
 *   "90532..."       -> "905321112233"
 * Returns "" if phone is empty or too short.
 */
export function phoneToWhatsApp(phone) {
  if (!phone) return "";
  let digits = String(phone).replace(/\D/g, "");
  if (!digits) return "";
  if (digits.startsWith("90") && digits.length === 12) return digits;
  if (digits.startsWith("0") && digits.length === 11) return "90" + digits.slice(1);
  if (digits.length === 10) return "90" + digits;
  // last-ditch: ensure it starts with country code if 11+ digits
  if (digits.length >= 11) return digits;
  return "";
}

/** Build a WhatsApp URL that opens the WhatsApp app directly via the
 * `whatsapp://` URI scheme — bypasses any blocked WhatsApp web domains.
 * Works on:
 *  - Windows/Mac: opens the WhatsApp Desktop app if installed
 *  - Android/iOS: opens the WhatsApp mobile app
 * If the app is NOT installed, the browser will show "couldn't open" — in
 * that case the user can install WhatsApp Desktop (free) from whatsapp.com.
 */
export function buildWhatsAppUrl(phone, message) {
  const w = phoneToWhatsApp(phone);
  if (!w) return "";
  const text = message ? `&text=${encodeURIComponent(message)}` : "";
  return `whatsapp://send?phone=${w}${text}`;
}

export default api;
